/* global Swiper */
// *******************************************************************************
// 1.0 - Image-card Slider
// *******************************************************************************

const imageCardSliderElements = document.querySelectorAll('[data-slider="image-card-slider"]');

const imageCardSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    480: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
};

imageCardSliderElements.forEach((el) => {
  const imageCardSliderParent = el.closest('.sc-image-card-slider');
  const arrowRight = imageCardSliderParent.querySelector('.arrow-right');
  const arrowLeft = imageCardSliderParent.querySelector('.arrow-left');

  imageCardSliderOptions.navigation.nextEl = arrowRight;
  imageCardSliderOptions.navigation.prevEl = arrowLeft;
  // eslint-disable-next-line no-new
  new Swiper(el, imageCardSliderOptions);
});
